'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = getFileItem;
function getFileItem(file, fileList) {
    var matchWay = !file.uid ? 'byName' : 'byUid';
    var target = fileList.filter(function (item) {
        if (matchWay === 'byName') {
            return item.name === file.name;
        }
        return item.uid === file.uid;
    })[0];
    return target;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@alife/next/lib/_components/@alife/next-upload/lib/get-file-item.js
// module id = 473
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11